import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {DropdownOption} from '../../../../../../models/dropdown-option.model';
import * as Validation from '../../../../../shared/constants/validation.constants';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../../../../state/app.state';
import {Router} from '@angular/router';
import {CommonService} from '../../../../../shared/services/common.service';
import {FetchMeasurementFilterRequest, FetchStatusFilterRequest} from '../../../core/clients-list.actions';
import {measurementFilter} from '../../../core/clients-list.selectors';
import {ClientListService} from '../../../services/client-list.service';

@Component({
  selector: 'app-measurement-information-filter',
  templateUrl: './measurement-information-filter.component.html',
  styleUrls: ['./measurement-information-filter.component.css']
})
export class MeasurementInformationFilterComponent implements OnDestroy {

  private readonly OnDestroy: Subject<any> = new Subject<any>();
  loading: boolean = false;
  statusFilterList: DropdownOption[] = [
    {
      key: 1,
      value: 'All'
    },
    {
      key: 2,
      value: 'Active'
    },
    {
      key: 3,
      value: 'Inactive'
    },
  ];
  errorMessages: any = {};
  validation = Validation;
  errorMessageMap = {
    'searchText': {
      required: 'This field is required.'
    },
    'status': {
      required: 'This field is required.'
    }
  }

  form = new FormGroup({
    searchText: new FormControl(''),
    status: new FormControl<number>({
      value: this.statusFilterList[0].key as number,
      disabled: false
    }, [Validators.required]),
  })

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private commonService: CommonService,
    private clientsListService: ClientListService,
  ) {
    this.store.dispatch(FetchMeasurementFilterRequest());
    this.store.dispatch(FetchStatusFilterRequest());
  }

  apply() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }
    if (!this.form.dirty) { // check is there any change
      return;
    }
    // changes just applied, so marking the form as un-dirty to avoid applying same filters again without changing anything
    this.form.markAsPristine();

    // EXTRACT VALUE FROM FORM//
    const {status, searchText} = this.form.getRawValue();
    const filters: any = {}
    if (status && status !== 1) {
      filters['isActive'] = status === 2;
    }
    if (searchText) {
      filters['searchText'] = searchText;
    }
    this.clientsListService.onMeasurementFilterChange.next(filters)
  }

  checkForErrors(currentField ?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  ngOnDestroy() {
    this.OnDestroy.next(null);
    this.OnDestroy.complete();
  }

}
